export const emailValidate = email => {
  const emailRegEx =
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return emailRegEx.test(String(email).toLowerCase());
};

export const loginValidate = login => login?.length === login.match(/[A-Za-z0-9_]/g)?.length;
